import { Command } from 'commander';
import inquirer from 'inquirer';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { resolveSpaceIdBySlug } from './show.js';

interface ArchiveOpts { skipConfirm?: boolean; org?: string; }

export async function runSpaceArchive(slug: string, opts: ArchiveOpts, client?: IV2Client): Promise<void> {
  if (!opts.skipConfirm) {
    const { ok } = await inquirer.prompt([{ type: 'confirm', name: 'ok',
      message: `Archive space "${slug}"? It will be hidden; URLs remain.`, default: false }]);
    if (!ok) { process.stdout.write('Cancelled.\n'); return; }
  }
  const c = client ?? await getV2Client(opts.org ?? undefined);
  const spaceId = await resolveSpaceIdBySlug(c, slug);
  await c.post(`/api/v2/spaces/${spaceId}/archive`);
  process.stdout.write(`✓ Archived space: ${slug}\n`);
}

export const spaceArchiveCommand = new Command('archive')
  .description('Archive a space (admin only)')
  .argument('<slug>', 'Space slug')
  .option('--skip-confirm', "Don't prompt for confirmation")
  .option('--org <slug>', 'Override active grid')
  .action(async (slug: string, opts: ArchiveOpts) => {
    try { await runSpaceArchive(slug, opts); }
    catch (err) { await handleV2Error(err); }
  });
